// src/pages/cities/CreateCity.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditCity from "../../components/cities/FormAddEditCity";

const CreateCity = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCity
                isEdit={false}
                onSubmitSuccess={() => navigate("/cities")}
            />
        </WrapperSection>
    );
};

export default CreateCity;
